import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setFiles, setPartnerProfileImages } from "../shared/sharedSlice";
import { notify } from "../../../utils/shared";
const API_URL = process.env.REACT_APP_API_URL;
const QUICK_TRANSFER_URL = `${API_URL}/quickTransfers`;
const ADD_VIDEO_DETAILS = `${API_URL}/videos`;
const UPDATE_VIDEO_DETAILS = `${API_URL}/videos`;
const APPROVE_VIDEO = `${API_URL}/videos/approve/`;
const COMMON_FILE_UPLOAD = `${API_URL}/fileUpload`;

export const getQuickTransfers = createAsyncThunk(
  "getQuickTransfers",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);
      const { page, limit, search = '' } = values
      const { data } = await axios.get(`${QUICK_TRANSFER_URL}?page=${page}&limit=${limit}&search=${search}`, {headers: {authorization: user.token}});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const getVehicleInfo = createAsyncThunk(
  "getVehicleInfo",
  async (vin: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${QUICK_TRANSFER_URL}/vehicle-info/${vin}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('kt-auth-react-v')}`
        }
      });
      return response.data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const commonFileUpload = createAsyncThunk(
  "commonFileUpload",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios({
        method: "post",
        url: `${COMMON_FILE_UPLOAD}`,
        data: values,
        headers: { "Content-Type": "multipart/form-data" },
      })
      dispatch(setFiles(data))
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const partnerProfileImage = createAsyncThunk(
  "commonFileUpload",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios({
        method: "post",
        url: `${COMMON_FILE_UPLOAD}`,
        data: values,
        headers: { "Content-Type": "multipart/form-data" },
      })
      dispatch(setPartnerProfileImages(data))
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateQuickTransferDetails = createAsyncThunk(
  "updateQuickTransferDetails",
  async (values: any, { rejectWithValue, dispatch, getState }) => {
    try {
      let selectedPage = values.get("selectedPage")
      const { data } = await axios.put(`${QUICK_TRANSFER_URL}/${values.get("id")}`, values);
      notify(data.responseMessage, 'success');
      const pageSize = (getState() as any).quickTransferList?.pageSize ?? 100;
      dispatch(getQuickTransfers({ page: selectedPage || 1, limit: pageSize }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const changeVideoStatus = createAsyncThunk(
  "changeVideoStatus",
  async (values: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.put(`${QUICK_TRANSFER_URL}${values?._id}`, { isVerified: !values?.isVerified });
      notify(data.responseMessage, 'success');
      const pageSize = (getState() as any).quickTransferList?.pageSize ?? 100;
      dispatch(getQuickTransfers({ page: values.selectedPage || 1, limit: pageSize }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addQuickTransferDetails = createAsyncThunk(
  "addQuickTransferDetails",
  async (values: any, { rejectWithValue, dispatch, getState }) => {
    try {
      let selectedPage = values.get("selectedPage");
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);
      const { data } = await axios.post(`${QUICK_TRANSFER_URL}`, values, {headers: {authorization: user.token}});

      notify(data.responseMessage, 'success');
      const pageSize = (getState() as any).quickTransferList?.pageSize ?? 100;
      dispatch(getQuickTransfers({ page: selectedPage || 1, limit: pageSize }))
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue({
        responseMessage:
          error.response?.data?.responseMessage || "Something went wrong",
      });
    }
  }
);


export const deleteQuickTransfer = createAsyncThunk(
  "deleteQuickTransfer",
  async (values: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.delete(`${QUICK_TRANSFER_URL}/${values.id}`);
      notify(data.responseMessage, 'success');
      const pageSize = (getState() as any).quickTransferList?.pageSize ?? 100;
      dispatch(getQuickTransfers({ page: values.selectedPage || 1, limit: pageSize }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const transferDeviceToDealer = createAsyncThunk(
  "transferDeviceToDealer",
  async (values: any, { rejectWithValue }) => {
    try {
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);
      const { data } = await axios.post(`${QUICK_TRANSFER_URL}/transfer/device`, values, {
        headers: { authorization: user.token }
      });
      notify(data.responseMessage, 'success');
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const transferDeviceToCustomer = createAsyncThunk(
  "transferDeviceToCustomer",
  async (values: any, { rejectWithValue }) => {
    try {
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);
      const { data } = await axios.post(`${QUICK_TRANSFER_URL}`, values, {headers: {authorization: user.token}});
      notify(data.responseMessage, 'success');
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue({
        responseMessage:
          error.response?.data?.responseMessage || "Something went wrong",
      });
    }
  }
);

export const getAllUsers = createAsyncThunk(
  "getAllUsers",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);
      const { data } = await axios.get(`${QUICK_TRANSFER_URL}/getAllUsers`, {headers: {authorization: user.token}});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
     // notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const transferDeviceToCustomerByVin = createAsyncThunk(
  "transferDeviceToCustomerByVin",
  async (values: any, { rejectWithValue }) => {
    try {
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);
      const { data } = await axios.post(`${QUICK_TRANSFER_URL}/transfer/device/by-vin`, values, {headers: {authorization: user.token}});
      notify(data.responseMessage, 'success');
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue({
        responseMessage:
          error.response?.data?.responseMessage || "Something went wrong",
      });
    }
  }
);

export const getImeisByVin = createAsyncThunk(
  "getImeisByVin",
  async (vin: string, { rejectWithValue }) => {
    try {
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);
      const { data } = await axios.get(`${QUICK_TRANSFER_URL}/imeis/${encodeURIComponent(vin)}`, {headers: {authorization: user.token}});
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue({
        responseMessage:
          error.response?.data?.responseMessage || "Something went wrong",
      });
    }
  }
);
